import React from 'react';
import { Box, Container, Typography, useTheme, alpha } from '@mui/material';
import { useLocation } from 'react-router-dom';

const SubHeader = () => {
  const theme = useTheme();
  const location = useLocation();

  const getPageTitle = () => {
    const routes = {
      '/kampanyalar': 'Kampanyalar',
      '/melek-yatirimcilar': 'Melek Yatırımcılar',
      '/nasil-yatirimci-olunur': 'Nasıl Yatırımcı Olunur',
      '/nasil-girisimci-olunur': 'Nasıl Girişimci Olunur',
    };

    if (location.pathname === '/profil') {
      const hash = window.location.hash.replace('#', '');
      const profileTitles = {
        'profile': 'Profilim',
        'entrepreneur': 'Girişimci Kayıt Formu',
        'investor': 'Yatırımcı Kayıt Formu',
        'security': 'Güvenlik & Girişler',
        'privacy': 'Gizlilik & Bildirimler',
        'campaigns': 'Kampanyalarım',
        'investments': 'Yatırım Hesabım',
      };
      return profileTitles[hash] || 'Profil';
    }

    if (location.pathname.includes('kampanya')) {
      const hash = window.location.hash.replace('#', '');
      const campaignTitles = {
        'profile': 'Kampanya Profili',
        'documents': 'Belge/Ödül/Hukuk',
        'team': 'Takım',
        'product': 'Ürün/Üretim Modeli',
        'market': 'Pazar/Rekabet/Hedef',
        'analysis': 'Analizler',
        'risks': 'Riskler',
        'funding': 'Fonlama',
        'company': 'Kuruluş',
        'financial': 'Finansal Tablolar',
        'media': 'Görsel/Video',
        'documents-other': 'Diğer Dokümanlar',
        'approval': 'Onaya Gönder',
        'preview': 'Önizleme',
      };
      return campaignTitles[hash];
    }

    return routes[location.pathname] || '';
  };

  const pageTitle = getPageTitle();

  // If there's no title for this route, don't render the SubHeader
  if (!pageTitle) return null;

  return (
    <Box
      sx={{
        bgcolor: theme.palette.mode === 'light' 
          ? alpha(theme.palette.grey[200], 0.8) 
          : alpha(theme.palette.grey[800], 0.8),
        py: 5,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Typography 
          variant="h3" 
          sx={{ 
            color: theme.palette.text.primary,
            fontWeight: 500
          }}
        >
          {pageTitle}
        </Typography>
      </Container>
    </Box>
  );
};

export default SubHeader; 